import { Box, BoxProps } from "@mui/material";
import type { SystemProps } from "@mui/system";
import type { Theme } from "@mui/material/styles";
import { ReactNode } from "react";
import { mergeSx, splitSystemProps } from "@/utils/system-props";

export type FlexProps = {
  children?: ReactNode;
} & BoxProps &
  SystemProps<Theme>;

const Flex = ({ children, sx, ...props }: FlexProps) => {
  const { systemSx, rest } = splitSystemProps(props);
  return (
    <Box {...rest} sx={mergeSx({ display: "flex", ...systemSx }, sx)}>
      {children}
    </Box>
  );
};

export default Flex;
